import { useEffect, useState, useRef } from 'react';
import { isMobileHost, getHost } from 'jweb';
import { LARGE_SCREEN_WIDTH } from '../utils/constants';

function getIsLargeScreen() {
  let isLargeScreen = false;
  if (typeof window !== 'undefined' && window.innerWidth >= LARGE_SCREEN_WIDTH) {
    isLargeScreen = true;
  }
  return isLargeScreen;
}

export const useIsLargeScreen = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(getIsLargeScreen());

  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(getIsLargeScreen());
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  return isLargeScreen;
};

export const useIsMobile = () => {
  const isMobile = useRef(false);

  const getIsMobile = async () => {
    isMobile.current = await isMobileHost();
  };

  useEffect(() => {
    getIsMobile();
  }, []);

  return isMobile.current;
};

export const useGetHostPlatform = () => {
  const hostPlatform = useRef();

  const getHostPlatform = async () => {
    hostPlatform.current = await getHost();
  };

  useEffect(() => {
    getHostPlatform();
  }, []);

  return hostPlatform.current;
};

export const useRefState = initialValue => {
  const [state, setState] = useState(initialValue);
  const stateRef = useRef(state);

  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  return [state, stateRef, setState];
};
